
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      relatedArticles: [],
      postTypeName: ``,
    };
  },
  computed: {
    categories () {
      return (this.post.categories) ? this.post.categories.map(cat => cat.id) : false;
    },
    numPosts () {
      return this.$store.state.config.related_posts.number_of_posts;
    },
    background () {
      return this.$store.state.config.related_posts.background;
    },
    hideDate () {
      return this.$store.state.config.related_posts.hide_date;
    },
    hideExcerpt () {
      return this.$store.state.config.related_posts.hide_excerpt;
    },
  },
  mounted () {
    this.postTypeName = this.post.type === `post` ? `News` : `${this.deslugify(this.post.type)}s`;
    this.getRelatedArticles(this.numPosts, this.categories);
  },
  methods: {
    async getRelatedArticles (numPosts = this.numPosts, categories = false, postType = this.post.type) {
      // Get latest 4 posts that match at least 1 of the categories
      const queryParams = {
        fields: `id,title,excerpt,date,image,slug,type,categories,acf`,
        posts: {
          post_type: postType,
          posts_per_page: numPosts,
          category: categories,
          post__not_in: [this.post.id], // Exclude current post
          post_status: `publish`,
        },
        options: {
          date_format: `d M Y`,
          image_size: `medium_large`,
        },
      };

      const request = await this.$getPosts(`/posts`, queryParams);
      if (request !== null) {
        this.relatedArticles.push(...request);
        if (this.relatedArticles.length < this.numPosts) {
          // Fill remaining related news with latest posts
          this.getRelatedArticles(this.numPosts - this.relatedNews.length, false);
        }
      } else {
        // TODO: if no posts available, get 4 latest posts (no category)
        this.postTypeName = `News`;
        this.getRelatedArticles(this.numPosts, false, [`post`, `match_preview`, `live`, `report`, `video`, `gallery`]);
      }
    },
  },
};
